import { createLink } from "@tanstack/react-router"
import { Button } from "@motleyhand/design"
import type { ComponentProps } from "react"

const ButtonLink = createLink((props: ComponentProps<typeof Button>) => (
  <Button nativeButton={false} render={<a />} {...props} />
))

export default ButtonLink
